// src/lib/dealsShelves.js
import { db } from '../firebase'
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from 'firebase/firestore'

// ---------- ADMIN : CRUD ÉTAGÈRES ----------

// toutes les étagères (admin)
export async function fetchAllDealsShelves() {
  const colRef = collection(db, 'dealsShelves')
  const snap = await getDocs(colRef)

  const rows = snap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
  }))

  // petit log debug
  console.log('[DealsShelves] fetchAllDealsShelves =>', rows)

  return rows.sort((a, b) => (a.order || 0) - (b.order || 0))
}

// étagères actives pour la partie publique
export async function fetchActiveDealsShelves() {
  const colRef = collection(db, 'dealsShelves')

  let snap
  try {
    // 🔹 on essaie de filtrer directement côté Firestore
    const qRef = query(
      colRef,
      where('isActive', '==', true),
      orderBy('order', 'asc')
    )
    snap = await getDocs(qRef)
  } catch (e) {
    console.warn(
      '[DealsShelves] query(isActive==true, orderBy(order)) a échoué, fallback simple getDocs',
      e
    )
    snap = await getDocs(colRef)
  }

  const rows = snap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
  }))

  // on filtre quand même au cas où certains docs n’ont pas isActive
  const actives = rows
    .filter((s) => s.isActive !== false) // true ou undefined
    .sort((a, b) => (a.order || 0) - (b.order || 0))

  console.log('[DealsShelves] fetchActiveDealsShelves =>', actives)

  return actives
}

export async function createDealsShelf(data) {
  const colRef = collection(db, 'dealsShelves')
  const payload = {
    title: '',
    categoryId: '',
    isActive: true,
    order: 0,
    limitProducts: 8,
    viewAllHref: '/catalog',
    ...data,
  }
  const ref = await addDoc(colRef, payload)
  return { id: ref.id, ...payload }
}

export async function updateDealsShelf(id, data) {
  const ref = doc(db, 'dealsShelves', id)
  await updateDoc(ref, data)
}

export async function deleteDealsShelf(id) {
  const ref = doc(db, 'dealsShelves', id)
  await deleteDoc(ref)
}

// ---------- PRODUITS POUR UNE ÉTAGÈRE ----------

function shuffleArray(arr) {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
      ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

// export async function fetchRandomProductsForShelf(
//   shelf,
//   maxProducts = 8
// ) {
//   const colRef = collection(db, 'productsShop')

//   // On lit un lot de produits
//   const snap = await getDocs(colRef)
//   const allProducts = snap.docs.map((d) => ({
//     id: d.id,
//     ...d.data(),
//   }))

//   console.log(
//     '[DealsShelves] total produitsShop =',
//     allProducts.length
//   )

//   if (!allProducts.length) return []

//   // --------- 1) Filtrage JS sur la catégorie du shelf ----------
//   if (shelf?.categoryId) {
//     const catId = String(shelf.categoryId)

//     const filtered = allProducts.filter((p) => {
//       // ⚠️ ton modèle Firestore : Categorie.Id / SubCategorie.Id
//       const catField =
//         p.categoryId ??
//         p.CategoryId ??
//         (p.Categorie && p.Categorie.Id) ??
//         (p.Category && p.Category.Id)

//       // si un jour tu veux filtrer par sous-catégories :
//       // const subCatField =
//       //   p.subCategoryId ??
//       //   p.SubCategoryId ??
//       //   (p.SubCategorie && p.SubCategorie.Id)

//       return catField != null && String(catField) === catId
//     })

//     console.log(
//       `[DealsShelves] produits trouvés pour categoryId=${catId} =>`,
//       filtered.length
//     )

//     if (filtered.length > 0) {
//       const shuffled = shuffleArray(filtered)
//       return shuffled.slice(0, maxProducts)
//     }
//   } else {
//     console.warn('[DealsShelves] shelf sans categoryId :', shelf)
//   }

//   // --------- 2) Fallback : si rien ne matche, on prend des produits aléatoires ----------
//   console.warn(
//     '[DealsShelves] Aucun produit pour cette categoryId, fallback aléatoire'
//   )

//   const shuffledAll = shuffleArray(allProducts)
//   return shuffledAll.slice(0, maxProducts)
// }
export async function fetchRandomProductsForShelf(shelf, maxProducts = 8) {
  const colRef = collection(db, "productsShop");

  // 1) Si shelf.categoryId existe -> on tente un fetch filtré Firestore
  if (shelf?.categoryId) {
    const catId = String(shelf.categoryId);

    try {
      // ✅ Requête Firestore (rapide) : produits validés + catégorie
      // ⚠️ adapte le champ "Categorie.Id" si chez toi c'est plutôt "categoryId"
      const qRef = query(
        colRef,
        where("validationStatus", "==", "validated"),
        where("Categorie.Id", "==", catId),
        limit(80) // on prend plus grand pour mieux randomiser
      );

      const snap = await getDocs(qRef);

      const items = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      console.log(`[DealsShelves] validés trouvés catId=${catId}:`, items.length);

      if (items.length) {
        const shuffled = shuffleArray(items);
        return shuffled.slice(0, maxProducts);
      }
    } catch (e) {
      console.warn("[DealsShelves] query category failed (index ?):", e?.code, e?.message);
      // on continue sur fallback
    }
  } else {
    console.warn("[DealsShelves] shelf sans categoryId :", shelf);
  }

  // 2) Fallback : on prend des produits validés aléatoires (sans catégorie)
  const fallbackSnap = await getDocs(
    query(colRef, where("validationStatus", "==", "validated"), limit(120))
  );

  const allValidated = fallbackSnap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
  }));

  console.warn("[DealsShelves] fallback aléatoire validés:", allValidated.length);

  const shuffledAll = shuffleArray(allValidated);
  return shuffledAll.slice(0, maxProducts);
}
export function normalizeProduct(p) {
  const img =
    p.imageUrl ||
    p.ImageUrl ||
    (Array.isArray(p.images) && p.images[0]) ||
    (Array.isArray(p.ImageUrl) && p.ImageUrl[0]) ||
    'https://via.placeholder.com/300x300?text=Image'

  const title =
    p.title ||
    p.name ||
    p.Name ||
    'Produit'

  const price = Number(
    p.salePrice ?? p.SalePrice ?? p.price ?? p.Price ?? 0
  )

  const oldPrice = Number(
    p.price && p.salePrice && p.salePrice < p.price
      ? p.price
      : p.Price && p.SalePrice && p.SalePrice < p.Price
        ? p.Price
        : 0
  )

  return { img, title, price, oldPrice }
}
